import React, { useEffect, useState } from "react";
import './Esquemas.scss'
import TitleView from "../../../components/atoms/TitleView/TitleView";
import GlovalCard from "../../../components/atoms/GlovalCard/GlovalCard";
import InputCalendario from "../../../components/atoms/InputCalendario/InputCalendario";
import InputLista from "../../../components/atoms/InputLista/InputLista";
import InputText from "../../../components/atoms/InputText/InputText";
import { getTurnos } from './EsquemasIntegracion.js'
import { getClients } from "../../monitoreo/MonitoreoServicios/MonitoreoServiciosIntegracion.js";
import { transferisServiciosIntegracion } from "../../monitoreo/TransferirServicios/transferisServiciosIntegracion.js";
import ButtonGris from "../../../components/atoms/ButtonGris/ButtonGris.jsx";
import { useNavigate } from "react-router-dom";
import Button from "../../../components/atoms/Button/Button.jsx";
import EditarEsquema from "./EditarEsquema/EditarEsquema.jsx";
import ScrollToTopButton from "../../../components/atoms/ScrollToTopButton.jsx";

const Esquemas = () => {
    const navigate = useNavigate()
    const [clientes, setClientes] = useState([])
    const [routes, setRoutes] = useState([])
    const [route, setRoute] = useState(null)
    const [cliente, setCliente] = useState(null)
    const [turnos, setTurnos] = useState([])
    const [active, setActive] = useState(false)
    const [idEsquema, setIdEsquema] = useState()
    useEffect(() => {
        getClients(setClientes)
    }, [])
    useEffect(() => {
        if (cliente) {
            transferisServiciosIntegracion.getRutesByIdClient(cliente.code, setRoutes)
        }
    }, [cliente])

    useEffect(() => {
        if (route) {
           
            getTurnos(route.code, setTurnos)
        }
    }, [route,active])

    return (
        <div className="Esquemas">
            <ScrollToTopButton/>
            <TitleView title={"Consulta de Esquemas"}></TitleView>
            <GlovalCard>
                {/* <div className="input-container">
                    <InputCalendario titulo={"Desde"}></InputCalendario>
                    <InputCalendario titulo={"Hasta"}></InputCalendario>
                </div> */}
                <div className="input-container flex-end">
                    <b><Button lecturaEscritura="E" className={"botonCrearEsquema"} onClick={() => { navigate("/programacion/esquemas/crear") }}>Crear Esquema</Button></b>
                </div>
                <div className="input-container">
                    <InputLista lecturaEscritura="E" options={clientes} value={cliente} onChange={(e) => { setCliente(e.value) }} titulo={"Cliente"}></InputLista>
                    <InputLista lecturaEscritura="E" options={routes} value={route} onChange={(e) => { setRoute(e.value) }} titulo={"Ruta"}></InputLista>
                </div>
                {
                    turnos.length > 0 ?
                        <>
                            <div className="horaiosContainer">
                                <GlovalCard>
                                    {
                                        turnos.map((item) => {
                                            return (
                                                <>
                                                    <div className={`columna ${item.ACTIVA == false ? "INACTIVA" : ""}`} >
                                                        <div className="left">

                                                            <div className="turno">{item.TURNO}</div>
                                                            <div className="hora"><InputText disabled={true} title="" type="time" value={item.HORA_INICIO}></InputText></div>
                                                            <div>a</div>
                                                            <div className="hora"><InputText disabled={true} title="" type="time" value={item.HORA_FIN}></InputText></div>
                                                        </div>
                                                        <div className="right">

                                                            <div className={`dia ${item.ACTIVA == false ? "INACTIVA" : ""} `}><div>D</div><input checked={item.DOMINGO ? true : false} type="checkbox" /></div>
                                                            <div className={`dia ${item.ACTIVA == false ? "INACTIVA" : ""} `}><div>L</div><input checked={item.LUNES ? true : false} type="checkbox" /></div>
                                                            <div className={`dia ${item.ACTIVA == false ? "INACTIVA" : ""} `}><div>M</div><input checked={item.MARTES ? true : false} type="checkbox" /></div>
                                                            <div className={`dia ${item.ACTIVA == false ? "INACTIVA" : ""} `}><div>M</div><input checked={item.MIERCOLES ? true : false} type="checkbox" /></div>
                                                            <div className={`dia ${item.ACTIVA == false ? "INACTIVA" : ""} `}><div>J</div><input checked={item.JUEVES ? true : false} type="checkbox" /></div>
                                                            <div className={`dia ${item.ACTIVA == false ? "INACTIVA" : ""} `}><div>V</div><input checked={item.VIERNES ? true : false} type="checkbox" /></div>
                                                            <div className={`dia ${item.ACTIVA == false ? "INACTIVA" : ""} `}><div>S</div><input checked={item.SABADO ? true : false} type="checkbox" /></div>
                                                            <div className="element">
                                                                <ButtonGris className={"borderButon"} onClick={() => { setActive(true);setIdEsquema(item.ID) }}><div style={{ fontSize: "20px" }}>✎</div></ButtonGris>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </>
                                            )
                                        })
                                    }
                                </GlovalCard>
                                {
                                    active ?
                                        <>
                                            <div className="modalEsquemas">
                                                <div className="background">
                                                    <EditarEsquema id_esquema={idEsquema} setActive={setActive}></EditarEsquema>
                                                </div>
                                            </div>
                                        </>:
                                        ""
                                }
                            </div>
                        </> : ""
                }
            </GlovalCard>
        </div>
    )
}
export default Esquemas